import { AxiosPromise, AxiosStatic } from "axios";
import { InvestmentUpdate, InvestmentUpdateInput } from "../types";

export const findInvestmentUpdates =
  (serverURL: string, appAxios: AxiosStatic) =>
  async ({ dealId }: InvestmentUpdateInput = {}): AxiosPromise<
    InvestmentUpdate[]
  > => {
    const params: Record<string, string | number> = {};
    if (dealId) params.dealId = dealId;

    return await appAxios.get(`${serverURL}/investment-updates`, {
      params,
      withCredentials: true,
    });
  };

export const markInvestmentUpdateAsViewed =
  (serverURL: string, appAxios: AxiosStatic) =>
  async (investmentUpdateId: string): AxiosPromise<void> =>
    await appAxios.post(
      `${serverURL}/investment-updates/${investmentUpdateId}/mark-viewed`,
      {
        withCredentials: true,
      }
    );
